class Product {
  constructor(product) {
    this.id = product.id;
    this.title = product.title;
    this.regNumber = product.regNumber;
    this.version = product.version;
    this.actualVersion = product.actualVersion;
    this.actualVersionNotes = product.actualVersionNotes;
    this.updateByClient = product.updateByClient;
  }
  get isExpiredVersion() {
    return this.actualVersion !== this.version;
  }
}

export {
  Product,
};